import { StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import { FormattedMessage, IntlShape } from 'react-intl';
import get from 'lodash/get';
import { Grid, Typography } from '@material-ui/core';

import { LayerSourceData } from 'yeself-common/typings/guide/Layer';

import FormInput from 'Console/components/common/form/FormInput';

import { validateDomain } from 'Console/utils/formUtils';

const styles: StyleRulesCallback = (theme) => ({
    editGuideFormWrapper: {
        marginTop: theme.typography.pxToRem(10),
        marginBottom: theme.typography.pxToRem(30),
        position: 'relative',
    },
    formLabel: {
        flexBasis: '23%',
        marginRight: theme.typography.pxToRem(42),
        [theme.breakpoints.down('sm')]: {
            'margin-right': 0,
        },
    },
    items: {
        flexWrap: 'nowrap',
        paddingBottom: theme.typography.pxToRem(20),
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            'justify-content': 'flex-start',
            'margin-right': 0,
            paddingBottom: theme.typography.pxToRem(20),
        },
    },
    formHeader: {
        marginBottom: theme.typography.pxToRem(45),
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.between('xs', 'md')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
});

interface CreateGuideFormProps extends WithStyles<typeof styles> {
    // TODO https://applearn.atlassian.net/browse/AD-2955
    form: any;
    guide: LayerSourceData;
    intl: IntlShape;
    title?: string;
    contentLanguageCode: string;
}

const CreateGuideForm = ({
    classes,
    form,
    intl,
    guide,
    title,
    contentLanguageCode,
}: CreateGuideFormProps) => (
    <Grid container className={classes.editGuideFormWrapper}>
        <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
            className={classes.formHeader}
        >
            {title && (
                <Grid item>
                    <Typography variant="h6">{title}</Typography>
                </Grid>
            )}
        </Grid>

        <Grid container>
            <Grid container direction="row" alignItems="center" className={classes.items}>
                <Typography className={classes.formLabel} variant="body1">
                    <FormattedMessage id="Guides.editForm.name" defaultMessage="Guide name" />
                </Typography>

                <Grid className={classes.formInput}>
                    <FormInput
                        isRequired
                        fullWidth={false}
                        form={form}
                        type="text"
                        initialValue={guide ? get(guide, `name[${contentLanguageCode}]`) : ''}
                        formItemKey="name"
                        placeholder={intl.formatMessage({
                            id: 'Guides.editForm.name',
                        })}
                    />
                </Grid>
            </Grid>

            <Grid container direction="row" alignItems="center" className={classes.items}>
                <Typography className={classes.formLabel} variant="body1">
                    <FormattedMessage
                        id="Guides.editForm.initialUrl"
                        defaultMessage="Initial URL of the webpage"
                    />
                </Typography>

                <Grid className={classes.formInput}>
                    <FormInput
                        fullWidth={false}
                        form={form}
                        type="text"
                        initialValue={guide && guide.initialUrl ? guide.initialUrl : ''}
                        formItemKey="initialUrl"
                        placeholder={intl.formatMessage({
                            id: 'Guides.editForm.initialUrl',
                        })}
                        additionalRules={[
                            {
                                validator: validateDomain,
                            },
                        ]}
                    />
                </Grid>
            </Grid>

            <Grid container direction="row" alignItems="center" className={classes.items}>
                <Typography className={classes.formLabel} variant="body1">
                    <FormattedMessage
                        id="Guides.editForm.description"
                        defaultMessage="Description of the guide"
                    />
                </Typography>

                <Grid className={classes.formInput}>
                    <FormInput
                        multiline
                        fullWidth={false}
                        form={form}
                        type="text"
                        initialValue={
                            guide && guide.description ? guide.description[contentLanguageCode] : ''
                        }
                        formItemKey="description"
                        placeholder={intl.formatMessage({
                            id: 'Guides.editForm.description',
                        })}
                    />
                </Grid>
            </Grid>
        </Grid>
    </Grid>
);

export default withStyles(styles)(CreateGuideForm);
